import React, { useState } from 'react';
import IslamFuturisticShell from '../../components/islam/IslamFuturisticShell';
import IslamContentList from '../../components/islam/IslamContentList';

const LANG_BUTTON =
  'rounded-full border px-4 py-1.5 text-sm font-medium transition focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400';

/**
 * Public list of Islam hub articles (category=article) and educational pieces.
 */
const IslamArticlesPage = () => {
  const [language, setLanguage] = useState('en');

  return (
  <IslamFuturisticShell
    browserTitle="Islamic Articles — Islam | PakPoints"
    metaDescription="Read Islamic articles, guides, and community resources on PakPoints."
    icon="📰"
    heading="Islamic Articles"
    tagline="Guides and reflections for daily life—mosques, community, and learning on PakPoints."
    accentOrbClass="bg-cyan-400/30"
  >
    <div className="space-y-10 text-left">
      <div className="flex flex-wrap gap-2 justify-center sm:justify-start" role="group" aria-label="Article language">
        <button
          type="button"
          className={`${LANG_BUTTON} ${
            language === 'en'
              ? 'border-cyan-400/60 bg-cyan-500/20 text-white'
              : 'border-white/15 text-slate-400 hover:text-white'
          }`}
          onClick={() => setLanguage('en')}
        >
          English
        </button>
        <button
          type="button"
          className={`${LANG_BUTTON} ${
            language === 'ur'
              ? 'border-cyan-400/60 bg-cyan-500/20 text-white'
              : 'border-white/15 text-slate-400 hover:text-white'
          }`}
          onClick={() => setLanguage('ur')}
        >
          اردو
        </button>
      </div>
      <section>
        <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-400 mb-4">
          {language === 'ur' ? 'تعلیمی مواد' : 'Educational articles'}
        </h2>
        <IslamContentList category="educational" language={language} detailBasePath="/islam/articles" />
      </section>
    </div>
  </IslamFuturisticShell>
  );
};

export default IslamArticlesPage;
